import type { ReactNode } from "react";
import { Button } from "./Button";
import { Empty, ErrorNote, Loading } from "./States";
import type { Paged } from "./useLoad";

/** What comes under a paged list: loading, the failure, the empty notice, or the "more" button. */
export function PagedFooter<T>({
  list,
  emptyTitle,
  children,
  moreLabel = "더 보기",
}: {
  list: Paged<T>;
  emptyTitle: string;
  /** what to do about the empty list */
  children?: ReactNode;
  moreLabel?: string;
}) {
  if (list.status === "loading") return <Loading />;
  if (list.status === "error") return <ErrorNote error={list.error} onRetry={list.reload} />;
  if (list.items.length === 0) return <Empty title={emptyTitle}>{children}</Empty>;
  return (
    <div className="more">
      {list.status === "more" && <Loading />}
      {list.status === "more-error" && <ErrorNote error={list.error} />}
      {list.status !== "more" && list.hasMore && <Button onClick={list.loadMore}>{moreLabel}</Button>}
    </div>
  );
}
